module.exports = __webpack_public_path__ + "img/katarina_outside_2.7899faf6.jpg";